import { getSignedUrl } from '@shoflo/polymer';
import { logProgramChange } from '@shoflo/studio-redux/utils';
import { withCurrentParams } from 'utils/actionUtils';
import { BROADCAST_UPDATE_SOURCE } from 'actions/Types';
import { setProgram } from 'actions/program';
import { setSourceUpdateStatus } from '@shoflo/studio-redux/actions';
import { UPDATE_PENDING } from '@shoflo/studio-redux/constants/SourceUpdateStatuses';

function updateSource(sourceId, changes, config = {}, endActionCallback) {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState) => {
      const { broadcastSources: sources } = getState();

      // deleteSource and updateSource are async calls, so we need to check
      // if the source is still in the list before updateSource api call
      //This will reduce the frequency of 404's on updateSource
      const isSourceInList = sources.sources.some(s => s._id === sourceId);
      if (!isSourceInList) return null;

      const action = {
        type: BROADCAST_UPDATE_SOURCE,
        request: async apiClient => {
          try {
            dispatch(setSourceUpdateStatus(sourceId, UPDATE_PENDING));
            const response = await apiClient.broadcast.updateSource(
              teamId,
              eventId,
              broadcastId,
              sourceId,
              changes
            );

            const updatedSource = await getSignedUrl(
              {
                ...response,
                team: teamId,
                event: eventId
              },
              apiClient
            );

            // Get state as late as possible so as to have the most recent version of liveSources and program.
            // This reduces or eliminates the possibility of a program update that overrides a newer version
            const { program } = getState();

            // This ensures we only update the program with source when we are not trying to show or hide it
            // What changes should make us update program? its usually the source value
            const sourceInProgram = program.layers.find(
              layer => layer?.source?._id === sourceId
            );

            const shouldUpdateProgram =
              sourceInProgram && changes.hidden === undefined;

            if (shouldUpdateProgram) {
              const updatedProgram = {
                ...program,
                layers: program.layers.map(layer => {
                  const { source } = layer;
                  // Actual source that was updated
                  if (source._id === sourceId) {
                    return {
                      ...layer,
                      source: {
                        ...updatedSource
                      }
                    };
                  }

                  return layer;
                })
              };

              dispatch(setProgram(updatedProgram));
              logProgramChange(getState, 'updateSource action');
              if (typeof endActionCallback === 'function') {
                endActionCallback();
              }
            }

            return updatedSource;
          } catch (error) {
            if (typeof endActionCallback === 'function') {
              endActionCallback({ error: error.message });
            }
            throw error;
          }
        },
        config
      };
      dispatch(action);
    }
  );
}

export default updateSource;
